<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE  ref="usersChildUpdate"  @submit="usersSubmit" :updateData="usersUpdateData" @uploadFile="uploadFile"></UPDATE>

  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Url from "@/views/crs36/util/url";
  import Qs from 'qs'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      uploadFile(col,result){
        col.data = result.join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if("delete" == clickName){
          //审核或启动等操作
          this.dataChanage(Url.experience.black.del,{id:row.id},res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }else if("批量上传" == clickName){
          this.$refs.usersChildUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.experience.black.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
        }
      })
      },
      usersSubmit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.experience.black.uploadUser,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.usersChildUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                { title: 'id', field: 'id',hidden:true},
                { title: '真实账号', field: 'realAccount'},
            ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              {title:'真实账号', field: 'realAccount'},
              {click:"查询",auth:"crs36:experience:black:find"},
              {click:"新增",auth:"crs36:experience:black:add"},
              {click:"批量上传",auth:"crs36:experience:black:upload"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.experience.black.qurey, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: '真实账号', field: 'realAccount'},
              { title: '创建者', field: 'creator'},
              { title: '创建时间', field: 'createTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              {title: window.$t('crs36.bt.operation'),width: 150,btnClick:[
                {name: window.$t('crs36.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit",auth:"crs36:experience:black:update"},
                {name:"删除",click:"delete",type:"primary",icon: "el-icon-delete",auth:"crs36:experience:black:delete"},
              ]},
          ]
        },
        usersUpdateData:{
          cols:[
            { title: '黑名单', field: 'blacks',type:11,action:Url.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/消息推送用户模板.xlsx"},
          ]
        },
      }
    }
  }
</script>
